import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { send } from "../../SendRequest";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getForm } from "../../redux/selector";
import AlertDialog from "../AlertDialog/AlertDialog";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";
const useStyles = makeStyles({
    tableRow: {
        textDecoration: "none!important",
    },
    advSearchBox: {
        backgroundColor: "rgb(245, 245, 245)",
        padding: "5px",
    },
    box: {
        padding: "15px",
    },
});

function EditYear() {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const form = useState(getForm());
    const {formLanguage } = form;
    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const initialDefaultValues = {
        scrn: "",
        submissionTime: "",
        treaSchlCode: "",
        schoolName: "",
        applicantName: "",
        schlLevlType: "",
        schlFinanceTpye: "",
    };

    useEffect(() => {
        i18n.changeLanguage(formLanguage);
    }, [formLanguage]);

    const schema = yup.object().shape({
        default: yup
            .number()
            .typeError(t("errorMsg.typeError"))
            .max(99, t("errorMsg.typeError"))
            .positive(t("errorMsg.typeError"))
            .integer(t("errorMsg.typeError"))
            .required(t("errorMsg.required")),
        101: yup
            .number()
            .typeError(t("errorMsg.typeError"))
            .max(99, t("errorMsg.typeError"))
            .positive(t("errorMsg.typeError"))
            .integer(t("errorMsg.typeError"))
            .required(t("errorMsg.required")),
    });

    const {
        getValues,
        register,
        reset,
        formState: { errors },
        handleSubmit,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: 0,
        mode: "onSubmit",
    });

    const [reloadOpen, setReloadOpen] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const handleParameter = (item) => {
        let value = "";
        try {
            value = JSON.parse(item[1]);
        } catch (error) {
            value = item[1];
        }
        let flag =
            Object.prototype.toString.call(value).indexOf("Object") > -1 ||
            Object.prototype.toString.call(value) === "[object Array]";
        return flag;
    };
    useEffect(() => {
        const option1 = {
            url: `${Config.CONTENT_PATH}/parameters/form/1`, //${selectedForm}
        };
        dispatch(send("FORM_PARAMETER", option1))
        .then((res) => res.json())
        .then((data) => {
            Object.entries(data.parameter).map((item) => {
                if (handleParameter(item)) {
                    initialDefaultValues[item[0]] = JSON.parse(item[1]);
                } else {
                    initialDefaultValues[item[0]] = item[1];
                }
            });

            initialDefaultValues[`default`] = data.reminder.completedSavedYears;
            reset(initialDefaultValues);
        });
    

        const option2 = {
            url: `${Config.CONTENT_PATH}/parameters/form/101`, //${selectedForm}
        };
        dispatch(send("FORM_PARAMETER", option2))
        .then((res) => res.json())
        .then((data) => {
            Object.entries(data.parameter).map((item) => {
                if (handleParameter(item)) {
                    initialDefaultValues[item[0]] = JSON.parse(item[1]);
                } else {
                    initialDefaultValues[item[0]] = item[1];
                }
            });
            initialDefaultValues[`101`] = data.reminder.completedSavedYears;
            reset(initialDefaultValues);
        });
    }, []);

    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };

    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    const onSubmit = (data) => {
        const reminderTemp = {};
        data[`formId`] = -1;
        Object.assign(reminderTemp, {
            default: parseInt(getValues("default")),
            101: parseInt(getValues("101")),
        });

        //data[`reminder`] = reminderTemp;
        const option = {
            url: `${Config.CONTENT_PATH}/parameters/EditYear`, //`${Config.CONTENT_PATH}/parameters/EditYear/1/${getValues("completedSavedYears")}`
            method: "POST",
            body: JSON.stringify(reminderTemp),
        };
        dispatch(send("SUBMIT_PARAMS", option))
        .then((res) => {
            if(res?.status == 200){
                setIsSavedOpen(true);
                setReloadOpen(false);
            }else{
                setIsSavedOpen(false);
                setReloadOpen(true);
            }
        })
    };
   
    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.portal.Reminder")}
                className="header"
            ></Header>
            <Box className="container">
                <AlertDialog
                    formOpen={reloadOpen}
                    content={t("common.reload.popup.msg")}
                    confirmButton={{
                        action: () => {
                            removeCookie("token", {
                                path: `${Config.CONTENT_PATH}`,
                            });
                            window.location.reload();
                        },
                        label: t("common.reload.popup.confirm"),
                    }}
                />
                <PortalNavbar aside className="drawer" />
                <main className="main">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box className={classes.box}>
                            <Typography variant="h6">
                                {t("common.portal.completedSavedYears")}
                            </Typography>
                            <Paper
                                sx={{ outerWidth: "200px" }}
                                style={{ padding: "20px", width: "80%" }}
                            >
                                <CustomTextField
                                    unit={t("common.portal.years")}
                                    component="span"
                                    label={"Default"}
                                    style={{
                                        flex: 3,
                                        maxWidth: "150px",
                                    }}
                                    inputProps={register(
                                        "default",
                                        {
                                            required: t("errorMsg.required"),
                                        },
                                        { minLength: 4 }
                                    )}
                                ></CustomTextField>
                                <ErrorMsg message={errors.default?.message} />
                                <br />
                                <CustomTextField
                                    unit={t("common.portal.years")}
                                    component="span"
                                    label={"Form 101"}
                                    style={{
                                        flex: 3,
                                        maxWidth: "150px",
                                    }}
                                    inputProps={register(
                                        "101",
                                        {
                                            required: t("errorMsg.required"),
                                        },
                                        { minLength: 4 }
                                    )}
                                ></CustomTextField>
                                <ErrorMsg message={errors[101]?.message} />
                                <br />
                                <br />
                                <Box display="flex" justifyContent="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        {t("common.portal.saveBlock")}
                                    </Button>
                                </Box>
                            </Paper>
                        </Box>
                    </form>
                </main>
            </Box>
            {isSavedOpen ? SavedDialog(isSavedOpen) : null}
        </Container>
    );
}
export default EditYear;
